<script setup>
// Invólucro modal das estatísticas de campanha — usado pelo fluxo LEGADO
// (agendamentos do WhatsApp App via DataTable + CustomEvent global). Todo o
// conteúdo vive no CampaignStatisticsPanel, compartilhado com a aba
// "Estatísticas" do ScheduleDrawer (WhatsApp Oficial). O painel busca os
// dados frescos no próprio mount — o Modal só renderiza o corpo quando
// aberto (v-if interno), então abrir == montar.
import { ref } from 'vue';
import Modal from 'dashboard/components/Modal.vue';
import CampaignStatisticsPanel from './CampaignStatisticsPanel.vue';

const props = defineProps({
  campaignId: { type: Number, default: null },
  schedulingId: { type: Number, default: null },
  statistics: { type: Object, default: null },
  progressData: { type: Object, default: () => ({}) },
  holdStats: { type: Object, default: null },
  status: { type: String, default: '' },
  statusMessage: { type: String, default: '' },
});

const showModal = ref(false);

const open = () => {
  showModal.value = true;
};

const close = () => {
  showModal.value = false;
};

defineExpose({ open, close });
</script>

<template>
  <Teleport to="body">
    <Modal
      v-model:show="showModal"
      size="medium"
      :on-close="close"
      :show-close-button="false"
    >
      <div class="p-6 bg-n-solid-3 rounded-xl">
        <!-- Header -->
        <div class="flex items-center justify-between mb-6">
          <h2 class="text-lg font-semibold text-n-slate-12">
            {{ $t('CAMPAIGN.STATISTICS.CAMPAIGN_DETAILS') }}
          </h2>
          <button
            class="flex items-center justify-center size-8 rounded-lg hover:bg-n-slate-4 transition-colors"
            @click="close"
          >
            <span class="i-lucide-x size-5 text-n-slate-11" />
          </button>
        </div>

        <CampaignStatisticsPanel
          v-if="showModal"
          :campaign-id="props.campaignId"
          :scheduling-id="props.schedulingId"
          :statistics="props.statistics"
          :progress-data="props.progressData"
          :hold-stats="props.holdStats"
          :status="props.status"
          :status-message="props.statusMessage"
        />
      </div>
    </Modal>
  </Teleport>
</template>
